<div class="fk-flex">
  <!-- valid icon  -->
  <div
    *ngIf="
      (control &&
        control?.valid &&
        (value || value === 0) &&
        !control?.disabled &&
        !hasMatSuffix) ||
      (!control && value && !hasMatSuffix)
    "
    [style.display]="isShowValidationStatusIcon ? 'block' : 'none'"
    class="fk-relative"
    [ngClass]="{ 'fk-ml-1': !isLtr, 'fk-mr-1': isLtr}"
  >
    <i class="mdi mdi-check fk-text-success mdi-24px"></i>
  </div>

  <!-- invalid icon  -->
  <div
    *ngIf="
      control?.invalid &&
      control?.touched &&
      !control?.disabled &&
      !hasMatSuffix
    "
    [style.display]="isShowValidationStatusIcon ? 'block' : 'none'"
    class="fk-relative"
    [ngClass]="{ 'fk-ml-2': !isLtr, 'fk-mr-2': isLtr}"
    [matTooltip]="
      control.hasError('required')
        ? ('messages.validationError.globalRequired' | translate)
        : ('common.error' | translate)
    "
  >
    <i class="mdi mdi-alert-circle-outline fk-text-danger mdi-24px"></i>
  </div>
</div>
